<mat-form-field appearance="fill" class="language-select">
  <mat-label>
    <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.communicationLanguage"></sc-dictionary-label>
  </mat-label>
  <mat-select [formControl]="formControl" [required]="required">
    @for (language of availableLanguages; track language) {
      <mat-option [value]="language.key">
        <sc-dictionary-label dictionaryKey="common.enum.language.{{language.key}}"></sc-dictionary-label>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
